import React from 'react';
import { Button } from 'telstra-ui/components/button/Button';
import './submit-site-section.css';

const SubmitSiteSection = (props) => {
  const {
    submitButtonText,
    description,
    onSubmitSiteConfirmButton,
  } = props;
  return (
    <div className="row">
      <div className="col-12 button-section pl-sm-0">
        <Button
          variant="super"
          onClick={onSubmitSiteConfirmButton}
          state={'app'}
        >
          {submitButtonText}
        </Button>
      </div>
      <div className="col-12 text-section body18 pl-sm-0">
        {description}
      </div>
    </div>
  );
};

export default SubmitSiteSection;
